import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-block: 24px;
  gap: 25px;

  label,
  span {
    font-size: 14px;
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

export const DescriptionScroll = styled.div`
  width: 100%;
  max-height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
  word-break: break-word;
  padding-right: 6px;
`;
